<template>
  <van-notice-bar v-if="notice" class="noticeWrap" scrollable
      left-icon="volume-o"
      :text="notice"
  />
</template>

<script>
import {mapGetters, mapState} from "vuex";
import {_code} from "@utils/constant";
export default {
  name: "LiveNotice",
  computed:{
    ...mapGetters(["notice"])
  },
  mounted() {
    // 1. 定义处理函数，绑定 this
    this.handleSocketMessage = this.handleSocketMessage.bind(this);
    this.$store.commit('ADD_MESSAGE_LISTENER', this.handleSocketMessage);
  },
  beforeDestroy() {
    this.$store.commit('REMOVE_MESSAGE_LISTENER', this.handleSocketMessage);
  },
  methods:{
    handleSocketMessage(msg) {
      switch (msg.msgType) {
        case _code.RECHARGE_RED_PACKET_SUCCESS: //现金红包充值

          setTimeout(()=>{
            this.$store.commit("upLiveNotice",null);
          },12000)
          break;
      }
    }
  }
}
</script>

<style scoped>
.noticeWrap{
  width: 100%;
  position: fixed;
  top: 0px;
}
</style>